"use client";

interface ProductImageProps {
  productId: string;
  alt: string;
  className?: string;
  src?: string;
}

export function ProductImage({ productId, alt, className, src }: ProductImageProps) {
  const imageSrc = src || `/images/products/${productId}.svg`;
  
  return (
    <div className={className} style={{ width: "100%", height: "100%" }}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={imageSrc}
        alt={alt}
        loading="lazy"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
    </div>
  );
}
